import React from "react";

import ApplyButton from "../applyButton";

/*
interface CtaButtonProps {
  ctaLabel: string;
  to: string;
  buttonStyle: string;
  preset: string;
  extraButtonStyle: string;
  labelClass: string;
  arrowClass: string;
  onClick: () => void;
  showAsButton: boolean;
  type: string;
  arrowSize: string;
  showArrowIcon: boolean;
  target: string;
}
*/

/** 
 * CTA UI button component.
 * 
 * @param {Object} props - The props object.
 * @param {string} props.ctaLabel - The text to be displayed on the button.
 * @param {string} props.to - The URL to which the button should link.
 * @param {string} props.buttonStyle - The CSS class to be applied to the button.
 * @param {string} props.preset - The preset to be applied to the button.
 * @param {string} props.extraButtonStyle - Additional styles to be applied to the button.
 * @param {string} props.labelClass - Additional styles to be applied to the button label.
 * @param {string} props.arrowClass - Additional styles to be applied to the button arrow.
 * @param {string} props.preset - The preset to be applied to the button.
 * @param {function} props.onClick - The function to be called when the button is clicked.
 * @param {string} props.showAsButton - Whether to display the button as a button or a link.
 * @param {string} props.type - The type of the button.
 * @param {string} props.arrowSize - The size of the arrow.
 * @param {string} props.showArrowIcon - Whether to display the arrow icon.
 * @param {string} props.target - The target attribute for the link.
 */

const CtaButton = (props) => {
  const buttonPresets = Object.freeze({
    base: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-2 py-2 rounded-full border 
      hover:shadow-sm dark:rounded-sm
      ${props?.extraButtonStyle}`,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `${props?.arrowClass || ""} `
    },
    primary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-2 py-2 rounded-full border
      bg-red-light text-white border-red-light 
      hover:bg-white hover:border-black-lighter hover:text-black-lighter hover:shadow-sm
      dark:rounded-sm dark:text-gray-darker dark:bg-green-standard
      dark:hover:bg-gray-darker dark:hover:text-green-standard dark:border-green-standard`,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-white group-hover:stroke-black-lighter 
      dark:group-hover:stroke-green-standard dark:hover:stroke-green-standard dark:stroke-gray-darker 
      ${props?.arrowClass || ""} `
    },
    secondary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-4 py-2 rounded-full text-black-lighter border-black-lighter border 
      hover:bg-black-lighter hover:border-black-lighter hover:text-white hover:shadow-sm
      dark:rounded-sm dark:text-white dark:border-white dark:bg-gray-darker
      dark:hover:bg-white dark:hover:text-gray-darker `,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-black-lighter hover:stroke-white group-hover:stroke-white
      dark:stroke-white dark:hover:stroke-gray-darker dark:group-hover:stroke-gray-darker 
      ${props?.arrowClass || ""} `
    },
    tertiary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-2 py-2 rounded-full bg-white text-black-lighter border-black-lighter border 
      hover:bg-black-lighter hover:border-black-lighter hover:text-white hover:shadow-sm
      dark:rounded-sm dark:text-white dark:border-white dark:bg-darker
      dark:hover:bg-white dark:hover:text-gray-darker `,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-black-lighter hover:stroke-white group-hover:stroke-white
      dark:stroke-white dark:hover:stroke-gray-darker dark:group-hover:stroke-gray-darker 
      ${props?.arrowClass || ""} `
    },
    quaternary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-2 py-2 rounded-full bg-red-light text-white border-red-light border 
      hover:bg-white hover:border-black-lighter hover:text-black-lighter hover:shadow-sm
      dark:rounded-sm dark:text-gray-darker dark:bg-green-standard dark:hover:bg-white dark:bg-green-standard 
      dark:hover:bg-gray-darker dark:hover:text-green-standard dark:border-green-standard`,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-white group-hover:stroke-black-lighter 
      dark:group-hover:stroke-green-standard dark:hover:stroke-green-standard dark:stroke-gray-darker 
      ${props?.arrowClass || ""} `
    },
    quinary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-4 py-2 rounded-full bg-white text-black-lighter border-black-lighter border 
      hover:bg-black-lighter hover:border-black-lighter hover:text-white hover:shadow-sm
      dark:rounded-sm dark:text-gray-darker dark:border-gray-darker dark:bg-white
      dark:hover:bg-gray-darker  dark:hover:text-white `,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-black-lighter hover:stroke-white group-hover:stroke-white
      dark:stroke-white dark:hover:stroke-gray-darker dark:group-hover:stroke-gray-darker 
      ${props?.arrowClass || ""} `
    },
    senary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-2 py-2 rounded-full bg-white text-black-lighter border-black-lighter border
      dark:rounded-sm dark:text-white dark:border-white dark:bg-darker`,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-black-lighter
      dark:stroke-white 
      ${props?.arrowClass || ""} `
    }
  });

  const { preset } = props;

  return (
    <>
      {preset ? (
        <ApplyButton {...props} {...buttonPresets[preset]} />
      ) : (
        <ApplyButton {...props} />
      )}
    </>
  );
};

export default CtaButton;
CtaButton.defaultProps = {
  labelClass: "text-base leading-genericCta font-bold pr-2"
};
